import httpStatus from 'http-status'

export const ERROR_REASONS = {
  [httpStatus.UNAUTHORIZED]: {
    default: {
      accounts_reason: 'unauthorized',
    },
  },
  [httpStatus.TOO_MANY_REQUESTS]: {
    MAX_PHONE_VALIDATION_ATTEMPTS_REACHED: {
      accounts_reason: 'max_phone_validation',
      error: {
        title: 'Limite de verificações atingido',
        showContactUs: false,
        message: 'Esse telefone já foi utilizado para verificar uma conta nos últimos 30 dias.',
      },
    },
    MAX_ATTEMPTS_CHECK_PIN_CODE: {
      accounts_reason: 'max_account_check_attempts',
      error: {
        title: 'Limite diário de tentativas atingido',
        showContactUs: false,
        message: 'Tente novamente em {LOCK_TIME}.',
      },
    },
    default: {
      accounts_reason: 'rate_limit_exceeded',
      error: {
        title: null,
        showContactUs: false,
        message: 'Você excedeu o número de tentativas. Por favor, tente novamente mais tarde.',
      },
    },
  },
  [httpStatus.FORBIDDEN]: {
    PHONE_IN_BLACKLIST: {
      accounts_reason: 'phone_number_in_blacklist',
      error: {
        title: null,
        showContactUs: false,
        message: 'Este número não pode ser cadastrado novamente.',
      },
    },
    PHONE_IN_USE: {
      accounts_reason: 'phone_number_already_in_use',
      error: {
        title: null,
        showContactUs: false,
        message: 'Este número de telefone já está sendo usado na OLX.',
      },
    },
    ACCOUNT_LOCKED: {
      accounts_reason: 'account_locked',
      error: {
        title: 'Conta bloqueada.',
        showContactUs: true,
      },
    },
    INVALID_CODE: {
      accounts_reason: 'invalid_pin_code',
      error: {
        title: 'Código incorreto',
        showContactUs: false,
        message: 'Não foi possível validar seu telefone. Por favor, tente novamente.',
      },
    },
    INVALID_PIN_CODE: {
      accounts_reason: 'invalid_code',
      error: {
        title: 'Código incorreto.',
        showContactUs: false,
        message: remainingAttempts => {
          const attemptMessage = remainingAttempts === 1 ? 'tentativa' : 'tentativas'
          return `Você tem mais ${remainingAttempts} ${attemptMessage}. Ao esgotá-las, só poderá tentar de novo em 24h.`
        },
      },
    },
    NO_PIN_CODE: {
      accounts_reason: 'no_pin_code',
    },
  },
  default: {
    accounts_reason: 'unexpected_status_code',
    error: {
      showContactUs: false,
      message: 'Não foi possível validar seu telefone. Por favor, tente novamente.',
    },
  },
}

export const handleRevalidationPinCodePhoneExceptions = error => {
  const { response: { status, data } = {} } = error

  const errorReason = ERROR_REASONS[status] || ERROR_REASONS.default
  const specificReason = errorReason[data?.message] || errorReason?.default
  const errorInfo = specificReason?.error || ERROR_REASONS.default.error

  return {
    errorInfo: {
      ...errorInfo,
      message:
        typeof errorInfo.message === 'function'
          ? errorInfo.message(data?.details?.remaining_attempts)
          : errorInfo.message,
    },
    lurkerExtraData: {
      accounts_reason: specificReason?.accounts_reason ?? ERROR_REASONS.default.accounts_reason,
      accounts_status_code: status,
    },
  }
}
